import { format, differenceInMinutes } from 'date-fns';
const { db } = require('../FirebaseConfig');
const {
  ref,
  child,
  get,
  update,
  query,
  orderByChild,
  equalTo
} = require('firebase/database');

const queuesRef = ref(db, 'queues');

export const dbQueueWithCurDateRef = (queueId, path) => {
  const date = format(Date.now(), 'yyyy-MM-dd');
  if (queueId !== undefined && path)
    return ref(db, `queues/${queueId}/daily_stats/${date}/${path}`);
  else if (queueId !== undefined)
    return ref(db, `queues/${queueId}/daily_stats/${date}`);
  else return ref(db);
};

//Filter user's queues
export const getUsersQueues = async (userId) => {
  const usersQueuesQuery = query(queuesRef, orderByChild('userId'), equalTo(userId));
  const usersQueuesSnapshot = await get(usersQueuesQuery);
  if (usersQueuesSnapshot.exists()) {
    const usersQueues = await usersQueuesSnapshot.val();
    return usersQueues;
  } else {
    console.error('No queues found for this user.');
    return [];
  }
};

//Filter organization's queues
export const getOrganizationsQueues = async (orgId) => {
  const organizationsQueueQuery = query(
    queuesRef,
    orderByChild('organizationId'),
    equalTo(orgId)
  );
  const organizationsQueueSnapshot = await get(organizationsQueueQuery);
  if (organizationsQueueSnapshot.exists()) {
    const organizationsQueues = organizationsQueueSnapshot.val();
    return organizationsQueues;
  } else {
    console.error('No queues found for this organization.');
    return [];
  }
};

//Update queue by Id
export const updateQueueById = async (queueId, updates) => {
    try {
    await update(ref(db, `queues/${queueId}`), {
      ...updates
    });
  } catch (e) {
    console.error(e);
  }
};

// Get queue info

export function getQueueNameById(queueId) {
  return new Promise((resolve, reject) => {
    get(child(db, `/queues/${queueId}`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          return snapshot.val().name;
        } else {
          console.error('No data available');
        }
      })
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
}

export function getBasicQueueInfoByDate(queueId, date) {
  return new Promise((resolve, reject) => {

    get(ref(db, `/queues/${queueId}`))
      .then((snapshot) => {
        if (!snapshot.exists()) {
          console.warn('Queue not found for ID:', queueId);
          resolve({});
          return;
        }

        const queueInfo = snapshot.val();

        if (!date) date = format(Date.now(), 'yyyy-MM-dd');

        const basicInfo = {
          name: queueInfo.name || 'Undefined name',
          limit: !isNaN(Number(queueInfo.limit))
            ? Number(queueInfo.limit)
            : 'Unlimited',
          description: queueInfo.description,
          queueId: queueInfo.id,
          status: queueInfo.status || 'Active',
        };

        const guestTokens = queueInfo.daily_stats?.[date]?.guests || {};

        basicInfo['activeGuests'] = Object.values(guestTokens).filter(
          (g) => g.status === 'waiting' || g.status === 'waiting-notified'
        ).length;
        basicInfo['totalGuests'] = Object.values(guestTokens).length;

        resolve({ basicInfo, guests: guestTokens });
      })
      .catch((error) => {
        console.error('Error fetching queue data:', error);
        reject(error);
      });
  });
}


export function addNewGuestToken(token) {
  return new Promise((resolve, reject) => {
    getBasicQueueInfoByDate(token.queueId)
      .then((snapshot) => {
        const data = snapshot;
        let totalGuests = data.guests ? Object.values(data.guests).length : 0;
        const curPosition = data.guests
          ? Object.values(data.guests).filter(
              (g) => g.status && g.status.includes('waiting')
            ).length
          : 0;
        const newToken = { ...token };
        newToken.position = curPosition + 1;
        newToken.number = totalGuests + 1;

        //add to DB
        const updateList = {};
        updateList[`/guests/${token.id}`] = newToken;
        updateList['totalGuests'] = totalGuests + 1;
        const dbRef = dbQueueWithCurDateRef(token.queueId);
        update(dbRef, updateList);

        return 'Added new token: ', newToken.number;
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error in: ', error);
        reject(error);
      });
  });
}

export function getTokens(queueId, date) {
  return new Promise((resolve, reject) => {
    get(dbQueueWithCurDateRef(queueId))
      .then((snapshot) => {
        if (snapshot.exists()) {
          return Object.values(snapshot.val().guests);
        } else {
        }
      })
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
}

export function getTokenById(queueId, tokenId) {
  return new Promise((resolve, reject) => {
    get(dbQueueWithCurDateRef(queueId, `/guests/${tokenId}`))
      .then((snapshot) => {
        if (snapshot) {
          resolve({ ...snapshot.val() });
        }
      })
      .catch((error) => {
        console.error('Error in getting token: ', error.message);
        reject(error);
      });
  });
}

export function updateMesTokenId(queueId, guestId, mesTokenId) {
  return new Promise((resolve, reject) => {
    update(dbQueueWithCurDateRef(queueId, `/guests/${guestId}`), {
      notifyTokenId: mesTokenId,
    })
      .then(() => {
        resolve();
      })
      .catch((error) => reject(error));
  });
}

export function updateToken(queueId, guestId, data) {
  const curDate = format(Date.now(), 'yyyy-MM-dd');
  const dbRef = ref(
    db,
    `queues/${queueId}/daily_stats/${curDate}/guests/${guestId}`
  );
  return new Promise((resolve, reject) => {
    update(dbRef, { ...data })
      .then(() => {
        resolve('Updated token successfully.');
      })
      .catch((error) => reject(error));
  });
}

export function updateCheckInToken(token, tokenList) {
  const updatedList = [...tokenList];
  const startedTime = new Date(token.startedTime);
  const endTime = new Date();
  const waitTime = differenceInMinutes(endTime, startedTime);

  return new Promise((resolve, reject) => {
    update(dbQueueWithCurDateRef(token.queueId, `/guests/${token.id}`), {
      position: 0,
      endTime: endTime,
      waitTime: waitTime,
      status: 'served',
    })
      .then(() => {
        const position = token.position;
        const updatePositions = {};
        updatedList.forEach((t) => {
          if (t.position > position) {
            //update new posiotn list for guest in queue
            t.position = t.position - 1;
            updatePositions[`/guests/${t.id}/position`] = t.position;
          }
        });
        update(dbQueueWithCurDateRef(token.queueId), updatePositions);
        resolve(updatedList.filter((t) => t.id !== token.id));
      })
      .catch((err) => {
        console.error('Update action error: ', err.message);
        reject(err);
      });
  });
}
export function updateDoneToken(token) {
  const endTime = new Date().toISOString();
  const servingTime = new Date(token.servingTime) || endTime;
  const servingDuration = differenceInMinutes(endTime, servingTime);
  const updates = {};
  updates[`endTime`] = endTime;
  updates[`status`] = 'served';

  return new Promise((resolve, reject) => {
    update(dbQueueWithCurDateRef(token.queueId, `/guests/${token.id}`), updates)
      .then(() => resolve('Success'))
      .catch((err) => {
        console.error('Update action error: ', err.message);
        reject(err);
      });
  });
}

export function cancelGuest(token) {
  return new Promise((resolve, reject) => {
    const activeRef = dbQueueWithCurDateRef(token.queueId, '/guests');
    get(activeRef)
      // update(child(activeRef, `/${token.id}`), { status: 'canceled' })
      .then((snapshot) => {
        const updatePositions = {};
        updatePositions[`/${token.id}/status`] = 'canceled';

        const updatedList = Object.values(snapshot.val()).filter((value) =>
          value.status.startsWith('waiting')
        );
        updatedList.forEach((t) => {
          if (t.position > token.position) {
            updatePositions[`/${t.id}/position`] = t.position - 1;
          }
        });
        update(activeRef, updatePositions).catch((err) => reject(err));

        resolve({ status: 'success' });
      })
      .catch((error) => reject(error));
  });
}

export const removeToken = (guestToken) => {
  try {
    const activeRef = dbQueueWithCurDateRef(guestToken.queueId, '/guests');
    get(activeRef).then(async (snapshot) => {
      const updatePositions = {};
      updatePositions[`/${guestToken.id}/status`] = 'canceled';

      const updatedList = Object.values(snapshot.val()).filter((value) =>
        value.status.startsWith('waiting')
      );
      updatedList.forEach((t) => {
        if (t.position > guestToken.position) {
          updatePositions[`/${t.id}/position`] = t.position - 1;
        }
      });
      await update(activeRef, updatePositions);
    });
  } catch (error) {
    console.error('\tError by: ', error.message);
  }
};

export function moveNoShowUpGuest(token, tokenList) {
  const updatedList = [...tokenList];

  if (updatedList.length > 1) {
    return new Promise((resolve, reject) => {
      update(dbQueueWithCurDateRef(token.queueId, `/guests/${token.id}`), {
        position: updatedList.length,
      })
        .then((snapshot) => {
          const position = token.position;
          const updatePositions = {};
          updatedList.forEach((t) => {
            if (t.id === token.id) t.position = updatedList.length;
            else if (t.position > position) {
              t.position = t.position - 1;
              updatePositions[`/guests/${t.id}/position`] = t.position;
            }
          });
          update(dbQueueWithCurDateRef(token.queueId), updatePositions);
          updatedList.sort((a, b) => a.position - b.position);
          return resolve(updatedList);
        })
        .catch((err) => {
          console.error('Update action error: ', err.message);
          reject(err);
        });
    });
  } else return updatedList;
}

